// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"f4360184","703":"1eb27493"}[chunkId] + ".chunk.js";
};